import fp from 'lodash/fp';
import { createSelector } from 'reselect';

export const getInventoryGuestSummaryReport = fp.get(
  'inventory.reports.guestSummary'
);

export const getAll = createSelector(
  getInventoryGuestSummaryReport,
  fp.get('all')
);

export const getIsFetching = createSelector(
  getInventoryGuestSummaryReport,
  fp.get('fetching')
);
export const getIsFetched = createSelector(
  getInventoryGuestSummaryReport,
  fp.get('fetched')
);
export const getFetchingError = createSelector(
  getInventoryGuestSummaryReport,
  fp.get('fetchingError')
);
